import { createSelector } from 'reselect';
import {
  FIELD_REGION_REPORT_FEATURE,
  YIELD_ANALYSIS_FEATURE,
  SCOUTING_FEATURE,
} from '../constants/features';

/**
 * Returns field features
 * @param {Object} state
 * @return {Array}
 */
export const getFieldFeatures = (state) => state.field.features;

/**
 * Returns true when the region report feature is available
 * @param {Object} state
 * @return {Boolean}
 */
export const isFieldRegionReportFeatureAvailable = createSelector(
  [getFieldFeatures],
  (fieldFeatures) => fieldFeatures.includes(FIELD_REGION_REPORT_FEATURE)
);

/**
 * Returns true when the yield analysis feature is available
 * @param {Object} state
 * @return {Boolean}
 */
export const isFieldYieldAnalysisFeatureAvailable = createSelector(
  [getFieldFeatures],
  (fieldFeatures) => fieldFeatures.includes(YIELD_ANALYSIS_FEATURE)
);

/**
 * Returns true when the scouting feature is available
 * @param {Object} state
 * @return {Boolean}
 */
export const isFieldScoutingFeatureAvailable = createSelector(
  [getFieldFeatures],
  (fieldFeatures) => fieldFeatures.includes(SCOUTING_FEATURE)
);
